export default __webpack_public_path__ + "static/media/0x64afdf9e28946419e325d801fb3053d8b8ffdc23.9f631548.png";